import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import type { NavItem } from '@kangaroo/ui';

/** Visible to signed-in users; Billing resolves the account and enforces owner access. */
export const billingNavItem: NavItem = { label: 'Billing', path: '/billing', icon: <ReceiptLongOutlinedIcon />, tooltip: 'Usage, invoices, and payment settings.' };

export function legacyBillingDestination(pathname: string, search: string) {
  const params = new URLSearchParams(search);
  const legacy = pathname === '/plans'
    || (pathname === '/settings' && params.get('section') === 'billing')
    || (pathname === '/drivers' && (params.has('billing') || params.has('usage_billing') || params.get('setup') === 'complete'));
  if (!legacy) return null;
  const result = params.get('billing');
  if (result === 'success' || result === 'cancel' || result === 'portal') params.set('team_billing', result);
  params.delete('billing'); params.delete('section'); params.delete('setup');
  return `/billing${params.size ? `?${params}` : ''}`;
}
